module.exports = {
    formatDate(ISOString) {
        const date = new Date(ISOString);
        return (('0' + date.getDate()).slice(-2)) + '.' + (('0' + (date.getMonth() + 1)).slice(-2)) + '.' + date.getFullYear() + ' '
            + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2);
    },
    formatDateShort(ISOString) {
        const date = new Date(ISOString);
        return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ' '
            + (('0' + date.getDate()).slice(-2)) + '.' + (('0' + (date.getMonth() + 1)).slice(-2));
    },
    formatTimeShort(ISOString) {
        const date = new Date(ISOString);
        const today = new Date();
        const timeString = ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
        let dateString = '';
        if(date.getDate() !== today.getDate() || date.getMonth() !== today.getMonth() || date.getFullYear() !== today.getFullYear()) {
            dateString = ' ' + (('0' + date.getDate()).slice(-2)) + '.' + (('0' + (date.getMonth() + 1)).slice(-2)) + '.' + date.getFullYear();
        }
        return timeString + dateString;
    },
    DEFAULT_DELIVERY: 45,
    ITEMS_PER_PAGE: 20
}
